export const Testimonials = () => {
  const testimonials = [
    {
      quote: "I didn't finish it. The man who started reading it is dead.",
      author: "Marcus T."
    },
    {
      quote: "This isn't a book. It's a fucking weapon. I can't put it on my shelf. It stares at me.",
      author: "Sarah K."
    },
    {
      quote: "I haven't missed a 4AM wake-up in 67 days. I don't recognize the man I was before this.",
      author: "David R."
    },
    {
      quote: "Every page felt like someone yanked my skull open and forced me to look at my pathetic excuses.",
      author: "Anonymous"
    },
    {
      quote: "It doesn't motivate. It doesn't inspire. It shames you into execution. And that's the only thing that works.",
      author: "James W."
    },
    {
      quote: "I wish I could unread it. But I'm glad I can't. The old me is buried now.",
      author: "Lisa M."
    },
    {
      quote: "Feels like contraband. Like I'm not supposed to have this. Like it was written in blood.",
      author: "Tyler J."
    },
    {
      quote: "My therapist told me to stop reading it. I fired my therapist.",
      author: "Anonymous"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-secondary/30 to-void">
      <div className="container mx-auto px-4 max-w-6xl">
        <h2 className="text-5xl md:text-6xl font-black text-center mb-4 tracking-tight">
          <span className="text-blood-bright">Contraband Testimonials</span>
        </h2>
        <p className="text-center text-steel text-xl mb-20 italic">Shock Quotes</p>
        
        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="relative bg-card/20 backdrop-blur-sm border border-smoke p-8 transition-all hover:border-blood/50 group"
            >
              <div className="absolute top-4 left-4 text-6xl text-blood/20 font-serif">"</div>
              
              <blockquote className="relative z-10 pt-8">
                <p className="text-lg md:text-xl text-foreground font-medium mb-4 leading-relaxed">
                  {testimonial.quote}
                </p>
                <footer className="text-steel text-sm uppercase tracking-widest">
                 ,  {testimonial.author}
                </footer>
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
